import React from "react";
import DOMPurify from 'dompurify';

const WebContentTermsElectrod = ({props}) => {
return (
    <div
        dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
                props.state.webContentTerm,
                {USE_PROFILES: {html: true}}
            ),
        }}
    ></div>
    );
};

export default WebContentTermsElectrod;